import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import DatatableExpand from "../../Constants/DatatableExpand";
import {
  validateTokenStorage,
  PaginationHeaderYear,
  getHabitosAptitudes,
  TruncarNotas,
} from "./../../Constants/Util";
import { Row, Col, Button, Label, Container } from "reactstrap";
import { PENCIL } from "./../../Constants/SrcImages";
import REACT_PRINT_COMPONENT from "./../../Constants/React_print";
import {
  COLUMNS_GRADES,
  EXPAND_ROW_GRADE_BOLETINES,
} from "../../Constants/DatatableColumns";
import {
  getGradesBoletin,
  getRegistrationBoletin,
  getDataBoletin,
} from "../../Constants/Services";
import moment from "moment";
import {
  IRegistrationBoletin,
  IGradesBoletin,
  IGradeSelectedBoletin,
  IAsistant,
  IHabitosAptitudes,
  IPromedio,
} from "./../../Constants/Interfaces";

interface IBoletinesState {
  dataRegistration: IRegistrationBoletin[];
  dataRegistrationSelected: IRegistrationBoletin;
  dataAsistant: IAsistant[];
  dataHabitosAptitudes: IHabitosAptitudes[];
  dataPromedio: IPromedio[];
  dataGrades: IGradesBoletin[];
  dataGradeSelected: IGradeSelectedBoletin;
  isOpenModalAddRegistration: boolean;
  isOpenModalImport: boolean;
  isOpenModalChange: boolean;
  isOpenModalRemove: boolean;
  isOpenPanelBoletin: boolean;
  year: string;
  trimestre: string;
}

class Boletines extends Component<RouteComponentProps<{}>, IBoletinesState> {
  constructor(props: any) {
    super(props);
    this.state = {
      dataRegistration: [],
      dataPromedio: [],
      dataAsistant: [],
      dataHabitosAptitudes: [],
      dataRegistrationSelected: {
        gr_desc: "",
        per_cedula: "",
        per_consejero: "",
        per_id: "",
        per_lastname: "",
        per_name: "",
        reg_id: "",
        reg_year: "",
      },
      dataGrades: [],
      dataGradeSelected: {
        gr_id: "",
        gr_desc: "",
        ar_literal: "",
        per_consejero: "",
        cy_id: "",
      },
      isOpenModalAddRegistration: false,
      isOpenModalImport: false,
      isOpenModalChange: false,
      isOpenModalRemove: false,
      isOpenPanelBoletin: false,
      year: moment(new Date()).format("YYYY"),
      trimestre: "I",
    };

    this.fetchGrade = this.fetchGrade.bind(this);
    this.fetchRegistration = this.fetchRegistration.bind(this);
    this.rechargeTrimestre = this.rechargeTrimestre.bind(this);
    this.changeHeader = this.changeHeader.bind(this);
    this.handlerExportBoletinPreescolar =
      this.handlerExportBoletinPreescolar.bind(this);
    this.handlerExportBoletinPrimerCiclo =
      this.handlerExportBoletinPrimerCiclo.bind(this);
    this.panelBoletin = this.panelBoletin.bind(this);
    this.handlerSelectPerson = this.handlerSelectPerson.bind(this);
    this.handlerSelectBoletin = this.handlerSelectBoletin.bind(this);
    this.fetchDataBoletin = this.fetchDataBoletin.bind(this);
    this.fetchDataAllBoletin = this.fetchDataAllBoletin.bind(this);
    this.exportAllBoletin = this.exportAllBoletin.bind(this);
    this.handlerExportBoletinSegundoCiclo =
      this.handlerExportBoletinSegundoCiclo.bind(this);
  }

  async fetchRegistration({
    gr_id,
    gr_desc,
    ar_literal,
    per_consejero,
    cy_id,
  }: any) {
    const response = await getRegistrationBoletin(gr_id, this.state.year);
    this.setState({
      dataRegistration: response,
      dataGradeSelected: { ar_literal, gr_id, gr_desc, per_consejero, cy_id },
    });
  }

  async fetchGrade() {
    const response = await getGradesBoletin();
    this.setState({
      dataGrades: response,
    });
  }

  async fetchDataAllBoletin() {
    const props = this.state;
    var response;
    if (props.dataGradeSelected.ar_literal === "1") {
      response = await getDataBoletin(
        props.year,
        0,
        props.trimestre,
        0,
        props.dataGradeSelected.gr_id,
        1,
        true
      );
      this.setState({
        dataAsistant: response.ta,
        dataHabitosAptitudes: response.ha,
        dataPromedio: response.ab,
        isOpenPanelBoletin: true,
      });
    } else {
      response = await getDataBoletin(
        props.year,
        0,
        props.trimestre,
        0,
        props.dataGradeSelected.gr_id,
        0,
        true
      );
      this.setState({
        dataAsistant: response.ta,
        dataHabitosAptitudes: response.ha,
        dataPromedio: response.ab,
        isOpenPanelBoletin: true,
      });
    }
  }

  async fetchDataBoletin() {
    var response;
    const props = this.state;
    if (props.dataGradeSelected.ar_literal === "1") {
      response = await getDataBoletin(
        props.year,
        props.dataRegistrationSelected.reg_id,
        props.trimestre,
        props.dataRegistrationSelected.per_id,
        props.dataGradeSelected.gr_id,
        1,
        false
      );
    } else {
      response = await getDataBoletin(
        props.year,
        props.dataRegistrationSelected.reg_id,
        props.trimestre,
        props.dataRegistrationSelected.per_id,
        props.dataGradeSelected.gr_id,
        0,
        false
      );
    }

    this.setState({
      dataAsistant: response.ta,
      dataHabitosAptitudes: response.ha,
      dataPromedio: response.ab,
      isOpenPanelBoletin: true,
    });
  }

  componentDidMount() {
    if (validateTokenStorage()) {
      this.context.quitToken();
    }
    this.fetchGrade();
  }

  changeHeader({ year, operation }: any) {
    var currentYear = new Date();
    var result = year;
    if (operation === "left") result = parseInt(year) - 1;
    else {
      result = parseInt(year) + 1;
      if (result > currentYear.getFullYear())
        result = currentYear.getFullYear();
    }

    this.setState({
      year: result,
    });

    setTimeout(() => {
      this.fetchGrade();
    }, 1000);
  }

  rechargeTrimestre(trimestre: string) {
    this.setState({
      trimestre,
    });
  }

  panelBoletin() {
    this.setState((prevState) => ({
      isOpenPanelBoletin: !prevState.isOpenPanelBoletin,
    }));
  }

  exportAllBoletin(row: any) {
    this.fetchDataAllBoletin();
  }

  calc2Decimals(theform) {
    var num = theform.original.value,
      rounded = theform.rounded;
    var with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
    rounded.value = with2Decimals;
  }

  calc3Decimals(theform) {
    var num = theform.original.value,
      rounded = theform.rounded;
    var with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,3})?/)[0];
    rounded.value = with2Decimals;
  }

  handlerExportBoletinPreescolar() {
    const props = this.state;

    var boletin_id = [];
    var hashBoletin = {};
    var area = [];
    var hashArea = {};
    var materia = [];
    var materiaA = [];
    var materiaB = [];
    var areaA = [];
    var areaB = [];
    var columns = 0;
    var hashMateria = {};

    materia = props.dataPromedio.filter((o) =>
      hashMateria[o.as_id] || o.as_id === null
        ? false
        : (hashMateria[o.as_id] = true)
    );
    materiaA = materia.filter((o, i) => {
      if (i < materia.length / 2) {
        return o;
      }
      return null;
    });

    materiaB = materia.filter((o, i) => {
      if (i > materia.length / 2) {
        return o;
      }
      return null;
    });

    area = props.dataPromedio.filter((o) =>
      hashArea[o.ar_id] || o.ar_id === null ? false : (hashArea[o.ar_id] = true)
    );

    if(props.dataGradeSelected.gr_id==="3"){
      
    areaA = area.filter((o, i) => {
      if (o.ar_id === "10" || o.ar_id === "17" || o.ar_id === "11") {
        return o;
      }
      return null;
    });

    areaB = area.filter((o, i) => {
      if (o.ar_id === "16" || o.ar_id === "12") {
        return o;
      }
      return null;
    });
    }
    else{

      areaA = area.filter((o, i) => {
        if (o.ar_id === "13" || o.ar_id === "14" || o.ar_id === "19") {
          return o;
        }
        return null;
      });
  
      areaB = area.filter((o, i) => {
        if (o.ar_id === "15" || o.ar_id === "18") {
          return o;
        }
        return null;
      });
    }

    areaA.sort(function (a, b) {
      return a.ar_id - b.ar_id;
    });

    areaB.sort(function (a, b) {
      return a.ar_id - b.ar_id;
    });

    boletin_id = props.dataPromedio.filter((o) =>
      hashBoletin[o.bl_id] || o.bl_id === null
        ? false
        : (hashBoletin[o.bl_id] = true)
    );

    return (
      <React.Fragment>
        <div className="mt-4 boletin-container-padd">
          {boletin_id.map((data_bl, i) => {
            var tardanzas = [];
            var ausencias = [];
            var ti = 0;
            var tii = 0;
            var tiii = 0;
            var ai = 0;
            var aii = 0;
            var aiii = 0;
            props.dataAsistant.map((item) => {
              if (item.asi_asistant === "T" && item.bl_id === data_bl.bl_id)
                tardanzas.push({
                  asi_asistant: item.asi_asistant,
                  asi_trimestre: item.asi_trimestre,
                  count: item.count,
                });
              else if (
                item.asi_asistant === "A" &&
                item.bl_id === data_bl.bl_id
              )
                ausencias.push({
                  asi_asistant: item.asi_asistant,
                  asi_trimestre: item.asi_trimestre,
                  count: item.count,
                });
              return null;
            });

            ausencias.map((data, i) => {
              if (data.asi_trimestre === "I") {
                ai = data.count;
              } else if (data.asi_trimestre === "II") {
                aii = data.count;
              } else if (data.asi_trimestre === "III") {
                aiii = data.count;
              }
              return null;
            });

            tardanzas.map((data, i) => {
              if (data.asi_trimestre === "I") {
                ti = data.count;
              } else if (data.asi_trimestre === "II") {
                tii = data.count;
              } else if (data.asi_trimestre === "III") {
                tiii = data.count;
              }
              return null;
            });
            return (
              <React.Fragment key={i}>
                <Row>
                  <Col xs={12} className="text-center mt-4 mb-2">
                    <h5 className="font-weight-bold">
                      MINISTERIO DE EDUCACION
                    </h5>
                    <h4 className="font-weight-bold">THE KING'S SCHOOL</h4>
                    <h6>AVENIDA 3RA BARRIO EL CARMEN ENTRE CALLE F Y G SUR</h6>
                    <h5 className="font-weight-bold">
                      BOLETIN DE CALIFICACIONES
                    </h5>
                  </Col>
                </Row>

                <Row className="mb-1">
                  <Col xs={6} className="border-boletin">
                    <Label className="font-weight-body">
                      Cédula: &nbsp; &nbsp; &nbsp;{data_bl.per_cedula}
                      <br></br>
                      Nombre: &nbsp; &nbsp;{`${data_bl.per_name}`} <br></br>
                   
                    </Label>
                  </Col>
                  <Col xs={6} className="border-boletin">
                    <Label className="font-weight-body">
                      Año Lectivo: &nbsp; &nbsp;{" "}
                      {props.dataRegistrationSelected.reg_year === ""
                        ? props.year
                        : props.dataRegistrationSelected.reg_year}{" "} <br></br>
                      Grupo: &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                      &nbsp; {props.dataRegistrationSelected.gr_desc === ""
                        ? props.dataGradeSelected.gr_desc
                        : props.dataRegistrationSelected.gr_desc}{" "} <br></br>
                      Consejero(a): &nbsp; &nbsp;
                      {props.dataRegistrationSelected.per_consejero === ""
                        ? props.dataRegistration[0].per_consejero
                        : props.dataRegistrationSelected.per_consejero}{" "} <br></br>
                    </Label>
                  </Col>
                </Row>
                <Row>
                  <div className="border-boletin d-flex area-w">
                    <Label className="font-weight-bold label-boletin pl-3">
                      AREAS
                    </Label>
                  </div>
                  <div className="d-flex trimestre-container">
                    <div className="border-boletin text-center trimestre-w">
                      <Label className="font-weight-bold label-boletin">
                        I
                      </Label>
                    </div>
                    <div className="border-boletin text-center trimestre-w">
                      <Label className="font-weight-bold label-boletin">
                        II
                      </Label>
                    </div>
                    <div className="border-boletin text-center trimestre-w">
                      <Label className="font-weight-bold label-boletin">
                        III
                      </Label>
                    </div>
                  </div>

                  <div className="border-boletin area-w">
                    <Label className="font-weight-bold label-boletin pl-3">
                      AREAS
                    </Label>
                  </div>
                  <div className="d-flex trimestre-container">
                    <div className="border-boletin text-center trimestre-w">
                      <Label className="font-weight-bold label-boletin">
                        I
                      </Label>
                    </div>
                    <div className="border-boletin text-center trimestre-w">
                      <Label className="font-weight-bold label-boletin">
                        II
                      </Label>
                    </div>
                    <div className="border-boletin text-center trimestre-w">
                      <Label className="font-weight-bold label-boletin">
                        III
                      </Label>
                    </div>
                  </div>
                </Row>
                <Row className="height-870px">
                  {areaA.map((data) => {
                    columns = columns + 1;
                    return (
                      <React.Fragment key={data.ar_id}>
                        <Col xs={6} className={"text-left critico-"+data.ar_id}>
                          <Row className={"paddings-" + data.ar_id}>
                            <Col xs={12} className="border-r-black">
                              <Label className="font-weight-bold">
                                {data.ar_desc.toUpperCase()}
                              </Label>
                            </Col>
                            {materia.map((itemM, i) => {
                              if (
                                itemM.ar_id === data.ar_id
                              ) {
                                return (
                                  <React.Fragment key={i}>
                                    <Col
                                      xs={9}
                                      className="text-left ptop_unset pbottom_unset hei-25px pl-1"
                                    >
                                      <Label className="font-weight-body fonts-12">
                                        {itemM.as_desc}
                                      </Label>
                                    </Col>

                                    <Col
                                              xs={1}
                                              className="text-center ptop_unset pbottom_unset hei-25px p-0"
                                            >
                                              <Label className="font-weight-body-literal">
                                              {props.dataPromedio.map((dataMateria, index) => {
                                      if (
                                        dataMateria.as_id === itemM.as_id &&
                                        dataMateria.ar_id === data.ar_id &&
                                        dataMateria.bl_id === data_bl.bl_id
                                      ) {
                    
                                        return (
                                          <React.Fragment key={index}>
                                                                               {dataMateria.not_trimestre ===
                                                  "I" &&
                                                  dataMateria.not_literal} 
                                          </React.Fragment>
                                        );
                                      }
                                      return null;
                                    })}

            
                                              </Label>
                                            </Col>
                                            <Col
                                              xs={1}
                                              className="text-center ptop_unset pbottom_unset hei-25px p-0"
                                            >

                                              <Label className="font-weight-body-literal">
                                              {props.dataPromedio.map((dataMateria, index) => {
                                      if (
                                        dataMateria.as_id === itemM.as_id &&
                                        dataMateria.ar_id === data.ar_id &&
                                        dataMateria.bl_id === data_bl.bl_id
                                      ) {
                                        
                                        if(dataMateria.as_id==="56"){
       
                                        }
                                        return (
                                          <React.Fragment key={index}>
                                                {dataMateria.not_trimestre ===
                                                  "II" &&
                                                  dataMateria.not_literal}
                                          </React.Fragment>
                                        );
                                      }
                                      return null;
                                    })}
                                              </Label>
                                            </Col>
                                            <Col
                                              xs={1}
                                              className="text-center ptop_unset pbottom_unset hei-25px p-0"
                                            >
                                              <Label className="font-weight-body-literal">
                                              {props.dataPromedio.map((dataMateria, index) => {
                                      if (
                                        dataMateria.as_id === itemM.as_id &&
                                        dataMateria.ar_id === data.ar_id &&
                                        dataMateria.bl_id === data_bl.bl_id
                                      ) {
                 
                                        return (
                                          <React.Fragment key={index}>
                                                {dataMateria.not_trimestre ===
                                                  "III" &&
                                                  dataMateria.not_literal}
                                          </React.Fragment>
                                        );
                                      }
                                      return null;
                                    })}

                                              </Label>
                                            </Col>

         
                                  </React.Fragment>
                                );
                              }
                              return null;
                            })}
                          </Row>
                        </Col>
                      </React.Fragment>
                    );
                  })}
                  {areaB.map((data) => {
                    columns = columns + 1;
                    return (
                      <React.Fragment key={data.ar_id}>
                        <Col xs={6} className={"text-left critico-"+data.ar_id}>
                          <Row className={"paddings-" + data.ar_id}>
                            <Col xs={12} className="border-r-black">
                              <Label className="font-weight-bold">
                                {data.ar_desc.toUpperCase()}
                              </Label>
                            </Col>
                            {materia.map((itemM, i) => {
                              if (
                                itemM.ar_id === data.ar_id 
                                // &&
                                // itemM.bl_id === data_bl.bl_id
                              ) {
                                return (
                                  <React.Fragment key={i}>
                                    <Col
                                      xs={9}
                                      className="text-left ptop_unset pbottom_unset hei-25px pl-1"
                                    >
                                      <Label className="font-weight-body fonts-12">
                                        {itemM.as_desc}
                                      </Label>
                                    </Col>
                                    <Col
                                              xs={1}
                                              className="text-center ptop_unset pbottom_unset hei-25px p-0"
                                            >
                                              <Label className="font-weight-body-literal">
                                              {props.dataPromedio.map((dataMateria, index) => {
                                      if (
                                        dataMateria.as_id === itemM.as_id &&
                                        dataMateria.ar_id === data.ar_id &&
                                        dataMateria.bl_id === data_bl.bl_id
                                      ) {
                                        return (
                                          <React.Fragment key={index}>
                                                {dataMateria.not_trimestre ===
                                                  "I" &&
                                                  dataMateria.not_literal}
                                          </React.Fragment>
                                        );
                                      }
                                      return null;
                                    })}

                                              </Label>
                                            </Col>
                                            <Col
                                              xs={1}
                                              className="text-center ptop_unset pbottom_unset hei-25px p-0"
                                            >
                                              <Label className="font-weight-body-literal">
                                              {props.dataPromedio.map((dataMateria, index) => {
                                      if (
                                        dataMateria.as_id === itemM.as_id &&
                                        dataMateria.ar_id === data.ar_id &&
                                        dataMateria.bl_id === data_bl.bl_id
                                      ) {
                                        return (
                                          <React.Fragment key={index}>
                                                {dataMateria.not_trimestre ===
                                                  "II" &&
                                                  dataMateria.not_literal}
                                          </React.Fragment>
                                        );
                                      }
                                      return null;
                                    })}

                                              </Label>
                                            </Col>
                                            <Col
                                              xs={1}
                                              className="text-center ptop_unset pbottom_unset hei-25px p-0"
                                            >
                                              <Label className="font-weight-body-literal">
                                              {props.dataPromedio.map((dataMateria, index) => {
                                      if (
                                        dataMateria.as_id === itemM.as_id &&
                                        dataMateria.ar_id === data.ar_id &&
                                        dataMateria.bl_id === data_bl.bl_id
                                      ) {
                                        return (
                                          <React.Fragment key={index}>
                                                {dataMateria.not_trimestre ===
                                                  "III" &&
                                                  dataMateria.not_literal}
                                          </React.Fragment>
                                        );
                                      }
                                      return null;
                                    })}
                                              </Label>
                                            </Col>
 
                                  </React.Fragment>
                                );
                              }
                              return null;
                            })}
                          </Row>
                        </Col>
                      </React.Fragment>
                    );
                  })}
                </Row>

                <Row className="paddings-asiste">
                  <Col xs={6}></Col>
                  <Col xs={6} className="text-left">
                    <Label className="font-weight-bold label-boletin">
                      ASISTENCIA
                    </Label>
                  </Col>

                  <Col xs={6}></Col>
                  <Col xs={3} className="text-left border-boletin">
                    <Label className="font-weight-bold label-boletin">
                      Tardanzas
                    </Label>
                  </Col>
                  <Col xs={1} className="border-boletin ">
                    <Label className="font-weight-bold label-boletin">
                      {ti}
                    </Label>
                  </Col>
                  <Col xs={1} className="border-boletin">
                    <Label className="font-weight-bold label-boletin">
                      {tii}
                    </Label>
                  </Col>
                  <Col xs={1} className="border-boletin">
                    <Label className="font-weight-bold label-boletin">
                      {tiii}
                    </Label>
                  </Col>
                  <Col xs={6}></Col>
                  <Col xs={3} className="text-left border-boletin">
                    <Label className="font-weight-bold label-boletin">
                      Ausencias
                    </Label>
                  </Col>
                  <Col xs={1} className="border-boletin">
                    <Label className="font-weight-bold label-boletin">
                      {ai}
                    </Label>
                  </Col>
                  <Col xs={1} className="border-boletin">
                    <Label className="font-weight-bold label-boletin">
                      {aii}
                    </Label>
                  </Col>
                  <Col xs={1} className="border-boletin">
                    <Label className="font-weight-bold label-boletin">
                      {aiii}
                    </Label>
                  </Col>
                </Row>
                <Row className="paddings-criterios">
                  <Col xs={4}>
                    <Row className="boletin-observacion-h">
                      <Col xs={12}>
                        <Label className="font-weight-bold">
                          CRITERIOS DE EVALUACION
                        </Label>
                      </Col>
                      <Col xs={12} className="border-boletin">
                        <Label className="font-weight-bold">
                          LHL: Lo He Logrado
                        </Label>
                      </Col>
                      <Col xs={12} className="border-boletin">
                        <Label className="font-weight-bold">
                          LEL: Lo Estoy Logrando
                        </Label>
                      </Col>
                      <Col xs={12} className="border-boletin">
                        <Label className="font-weight-bold">
                          LVL: Lo Voy a Lograr
                        </Label>
                      </Col>
                      <Col xs={12} className="border-boletin">
                        <Label className="font-weight-bold">
                          N/A: No Aplica
                        </Label>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={8}>
                    <Row>
                      <Col xs={12}>
                        <Label className="font-weight-bold">
                          OBSERVACIONES
                        </Label>
                      </Col>
                    </Row>
                    <Row className="border-boletin boletin-observacion-h">
                      <Col xs={12}>
                        <Label className="font-weight-bold">Perido 1: </Label>
                      </Col>
                      <Col xs={12}>
                        <Label className="font-weight-bold">Perido 2:</Label>
                      </Col>
                      <Col xs={12}>
                        <Label className="font-weight-bold">Perido 3:</Label>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={6} className="text-center">
                    <Label className="font-weight-bold">
                      _______________________________________ <br></br>
                      Profesor(a) Consejero(a)
                    </Label>
                  </Col>
                  <Col xs={6} className="text-center">
                    <Label className="font-weight-bold">
                      _______________________________________ <br></br>
                      Gladys N. Méndez<br></br>
                      Director(a)
                    </Label>
                  </Col>
                  <Col xs={12} className="text-center mb-3">
                    <Label>
                      ______________________________________________________________________________________________________________________________________________
                      <br></br>
                      Nota: Este documento no es válido si no contiene el sello
                      del colegio y la firma del director(a).
                    </Label>
                  </Col>
                </Row>
              </React.Fragment>
            );
          })}
        </div>
      </React.Fragment>
    );
  }

  handlerExportBoletinPrimerCiclo() {
    const props = this.state;
    var prom_div = 1;
    var area = [];
    var boletin_id = [];
    var hashBoletin = {};
    var hashArea = {};
    var materia = [];
    var hashMateria = {};
    var materiaIng = [];
    var hashMateriaIng = {};
    area = props.dataPromedio.filter((o) =>
      hashArea[o.ar_id] || o.ar_id === null ? false : (hashArea[o.ar_id] = true)
    );
    materia = props.dataPromedio.filter((o) =>
      hashMateria[o.as_id] || o.as_id === null
        ? false
        : (hashMateria[o.as_id] = true)
    );
    materiaIng = props.dataPromedio.filter((o) =>
    hashMateriaIng[o.as_id] || o.as_id === null || o.as_mother !== "17"
      ? false
      : (hashMateriaIng[o.as_id] = true)
  );

    boletin_id = props.dataPromedio.filter((o) =>
      hashBoletin[o.bl_id] || o.bl_id === null
        ? false
        : (hashBoletin[o.bl_id] = true)
    );
    if (props.trimestre === "III") {
      prom_div = 3;
    } else if (props.trimestre === "II") {
      prom_div = 2;
    }
    return (
      <div className="mt-2 boletin-container-padd">
        {boletin_id.map((data_bl, i) => {
          var tardanzas = [];
          var ausencias = [];
          var ti = 0;
          var tii = 0;
          var tiii = 0;
          var ai = 0;
          var aii = 0;
          var aiii = 0;
          var piF = 0;
          var piiF = 0;
          var piiiF = 0;
          var pF = 0;

          var piF_t = 0;
          var piiF_t = 0;
          var piiiF_t = 0;
          var pF_t  = 0;


          //INGLES
          var pi_ing = 0;
          var pii_ing = 0;
          var piii_ing = 0;
          var piF_ing = 0;
          var piiF_ing = 0;
          var piiiF_ing = 0;
          var pF_ing = 0;
          var qty_ing_i = 0;
          var qty_ing_ii = 0;
          var qty_ing_iii = 0;
          //
          props.dataAsistant.map((item) => {
            if (item.asi_asistant === "T" && item.bl_id === data_bl.bl_id)
              tardanzas.push({
                asi_asistant: item.asi_asistant,
                asi_trimestre: item.asi_trimestre,
                count: item.count,
              });
            else if (item.asi_asistant === "A" && item.bl_id === data_bl.bl_id)
              ausencias.push({
                asi_asistant: item.asi_asistant,
                asi_trimestre: item.asi_trimestre,
                count: item.count,
              });
            return null;
          });

          ausencias.map((data, i) => {
            if (data.asi_trimestre === "I") {
              ai = data.count;
            } else if (data.asi_trimestre === "II") {
              aii = data.count;
            } else if (data.asi_trimestre === "III") {
              aiii = data.count;
            }
            return null;
          });

          tardanzas.map((data, i) => {
            if (data.asi_trimestre === "I") {
              ti = data.count;
            } else if (data.asi_trimestre === "II") {
              tii = data.count;
            } else if (data.asi_trimestre === "III") {
              tiii = data.count;
            }
            return null;
          });
          //INGLES
          props.dataPromedio.map((itemP_ing, i) => {
            if (
              itemP_ing.bl_id === data_bl.bl_id &&
              itemP_ing.as_mother === "17"
            ) {

              if (itemP_ing.not_trimestre === "I") {
                qty_ing_i = qty_ing_i + 1;
                // pi_ing = pi_ing + Number(itemP_ing.not_promedio);
                pi_ing = Number((Number(pi_ing) + Number(itemP_ing.not_promedio)).toFixed(2));
              } else if (itemP_ing.not_trimestre === "II") {
                qty_ing_ii = qty_ing_ii + 1;
                // pii_ing = pii_ing + Number(itemP_ing.not_promedio);
                pii_ing = Number((Number(pii_ing) + Number(itemP_ing.not_promedio)).toFixed(2));
              } else if (itemP_ing.not_trimestre === "III") {
                qty_ing_iii = qty_ing_iii + 1;
                // piii_ing = piii_ing + Number(itemP_ing.not_promedio);
                piii_ing = Number((Number(piii_ing) + Number(itemP_ing.not_promedio)).toFixed(2));
              }
            }
            return null;
          });
          piF_ing = Number((pi_ing / qty_ing_i).toFixed(2));
          piiF_ing =  Number(( pii_ing / qty_ing_ii).toFixed(2));
          piiiF_ing =  Number((piii_ing / qty_ing_iii).toFixed(2));
          pF_ing = pF_ing + Number(Number.isNaN(piF_ing)?0:piF_ing) + Number(Number.isNaN(piiF_ing)?0:piiF_ing) + Number(Number.isNaN(piiiF_ing)?0:piiiF_ing);
          var HabitosA = [];
         
          return (
            <React.Fragment key={i}>
              <div className="container-print">
                <Row>
                  <Col xs={12} className="text-center mt-5 mb-4">
                    <h5 className="font-weight-bold">
                      MINISTERIO DE EDUCACION
                    </h5>
                    <h4 className="font-weight-bold">THE KING'S SCHOOL</h4>
                    <h6>AVENIDA 3RA BARRIO EL CARMEN ENTRE CALLE F Y G SUR</h6>
                    <h5 className="font-weight-bold">
                      BOLETIN DE CALIFICACIONES
                    </h5>
                  </Col>
                </Row>
                <Row className="mb-2 mt-2">
                  <Col xs={6} className="border-boletin">
                    <Label className="font-weight-body">
                      Cédula: &nbsp; &nbsp; &nbsp;{data_bl.per_cedula}
                      <br></br>
                      Nombre: &nbsp; &nbsp;{`${data_bl.per_name}`} <br></br>
                      <br></br>
                    </Label>
                  </Col>
                  <Col xs={6} className="border-boletin">
                    <Label className="font-weight-body">
                      Año Lectivo: &nbsp; &nbsp;{" "}
                      {props.dataRegistrationSelected.reg_year === ""
                        ? props.year
                        : props.dataRegistrationSelected.reg_year}{" "}
                      <br></br>
                      Grupo: &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                      &nbsp;{" "}
                      {props.dataRegistrationSelected.gr_desc === ""
                        ? props.dataGradeSelected.gr_desc
                        : props.dataRegistrationSelected.gr_desc}{" "}
                      <br></br>
                      Consejero(a): &nbsp; &nbsp;
                      {props.dataRegistrationSelected.per_consejero === ""
                        ? props.dataRegistration[0].per_consejero
                        : props.dataRegistrationSelected.per_consejero}{" "}
                      <br></br>
                    </Label>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={6} className="border-boletin  text-left">
                    <Label className="font-weight-bold label-boletin">
                      AREAS
                    </Label>
                  </Col>
                  <Col xs={1} className="border-boletin text-center">
                    <Label className="font-weight-bold label-boletin">I</Label>
                  </Col>
                  <Col xs={1} className="border-boletin  text-center">
                    <Label className="font-weight-bold label-boletin">II</Label>
                  </Col>
                  <Col xs={1} className="border-boletin  text-center">
                    <Label className="font-weight-bold label-boletin">
                      III
                    </Label>
                  </Col>
                  <Col xs={3} className="border-boletin text-center">
                    <Label className="font-weight-bold label-boletin">
                      FINAL
                    </Label>
                  </Col>
                </Row>
                <Row>
                  {area.map((data) => {
                    return (
                      <React.Fragment key={data.ar_id}>
                        <Col xs={12} className="text-left">
                          <Label className="font-weight-bold">
                            {data.ar_desc.toUpperCase()}
                          </Label>
                        </Col>
                        {materia.map((itemM, i) => {
                          if (
                            itemM.ar_id === data.ar_id &&
                            itemM.as_mother === "0"
                          ) {
                            var pi = 0;
                            var pii = 0;
                            var piii = 0;
                            var qtyNotas_i=0;
                            var qtyNotas_ii=0;
                            var qtyNotas_iii=0;
                            props.dataPromedio.map((itemP, i) => {

                              if (itemP.bl_id === data_bl.bl_id) {
                                if ( itemP.not_trimestre === "I" && itemP.ar_id === data.ar_id &&itemM.as_id === itemP.as_id) {
                                  qtyNotas_i = qtyNotas_i+1;
                                  pi = Number((Number(pi) + Number(itemP.not_promedio)).toFixed(2));
                                } else if (
                                  itemP.not_trimestre === "II" && itemP.ar_id === data.ar_id && itemM.as_id === itemP.as_id) {
                                  qtyNotas_ii = qtyNotas_ii+1;
                                  pii = Number((Number(pii) + Number(itemP.not_promedio)).toFixed(2));
                                } else if ( itemP.not_trimestre === "III" && itemP.ar_id === data.ar_id && itemM.as_id === itemP.as_id) {
                                  qtyNotas_iii = qtyNotas_iii+1;
                                  piii = Number((Number(piii) + Number(itemP.not_promedio)).toFixed(2));
                                }
                              }
                              return null;
                            });
                            if(qtyNotas_i===0){
                              qtyNotas_i=1;
                            }
                            if(qtyNotas_ii===0){
                              qtyNotas_ii=1;
                            }
                            if(qtyNotas_iii===0){
                              qtyNotas_iii=1;
                            }

                            piF = Number((pi/qtyNotas_i).toFixed(2));
                            piiF =Number((pii/qtyNotas_ii).toFixed(2));
                            piiiF = Number((piii/qtyNotas_iii).toFixed(2));
                            pF =  Number((piF + piiF + piiiF).toFixed(2));
                           
                            piF_t = piF_t + Number(piF.toFixed(2));
                            piiF_t = piiF_t + Number(piiF.toFixed(2));
                            piiiF_t = piiiF_t + Number(piiiF.toFixed(2));
                            pF_t = pF_t+ piF_t +piiF_t +piiiF_t;
                            console.log(piiiF_t,piiF_ing)
                            return (
                              <React.Fragment key={i}>
                                <Col
                                  xs={6}
                                  className="text-left ptop_unset pbottom_unset"
                                >
                                  <Label className="font-weight-body">
                                    {itemM.as_desc}
                                  </Label>
                                </Col>
                                <Col
                                  xs={1}
                                  className="text-center ptop_unset pbottom_unset"
                                >
                                  <Label className="font-weight-body">
                                    {pi === 0 ? null : piF.toFixed(2)}
                                  </Label>
                                </Col>
                                <Col
                                  xs={1}
                                  className="text-center ptop_unset pbottom_unset"
                                >
                                  <Label className="font-weight-body">
                                    {pii === 0 ? null : piiF.toFixed(2)}
                                  </Label>
                                </Col>
                                <Col
                                  xs={1}
                                  className="text-center ptop_unset pbottom_unset"
                                >
                                  <Label className="font-weight-body">
                                    {piii === 0 ? null : piiiF.toFixed(2)}
                                  </Label>
                                </Col>
                                <Col xs={3} className="text-center">
                                  {" "}
                                  <Label className="font-weight-body">
                                    {" "}
                                    {
                                     TruncarNotas(Number(pF)/prom_div,2)}
                                  </Label>{" "}
                                </Col>
                              </React.Fragment>
                            );
                          }
                          return null;
                        })}
                        {pF !== 0 && data.ar_id === "7" ? (
                          <React.Fragment key={i}>
                            <Col
                              xs={6}
                              className="text-left ptop_unset pbottom_unset"
                            >
                              <Label className="font-weight-body">Inglés</Label>
                            </Col>
                            <Col
                              xs={1}
                              className="text-center ptop_unset pbottom_unset"
                            >
                              <Label className="font-weight-body">
                                {piF_ing === 0 
                                  ? null
                                  : 
                                  Number.isNaN(piF_ing)?null:
                                  piF_ing}
                              </Label>
                            </Col>
                            <Col
                              xs={1}
                              className="text-center ptop_unset pbottom_unset"
                            >
                              <Label className="font-weight-body">
                                {piiF_ing === 0 || piiF_ing ===   NaN
                                  ? null
                                  : 
                                  Number.isNaN(piiF_ing)?null:
                                 piiF_ing}
                              </Label>
                            </Col>
                            <Col
                              xs={1}
                              className="text-center ptop_unset pbottom_unset"
                            >
                              <Label className="font-weight-body">
                                {piiiF_ing === 0 
                                  ? null
                                  : 
                                  Number.isNaN(piiiF_ing)?null:
                                  piiiF_ing}
                              </Label>
                            </Col>
                            <Col xs={3} className="text-center">
                              {" "}
                              <Label className="font-weight-body">
                                {" "}
                                {(Number(pF_ing) / prom_div).toFixed(2)}
                              </Label>{" "}
                            </Col>
                          </React.Fragment>
                        ) : null}
                      </React.Fragment>
                    );
                  })}
                  <Col xs={6} className="text-left ptop_unset pbottom_unset">
                    <Label className="font-weight-bold">PROMEDIO FINAL</Label>
                  </Col>
                  <Col xs={1} className="text-center ptop_unset pbottom_unset">
                    <Label className="font-weight-body">
                      { 
                      piF_t === 0
                        ? null
                        : ( 
                            (Number(piF_t) + Number(piF_ing)) /
                            (materia.length - materiaIng.length + 1)
                          ).toFixed(2)
                            // .toString()
                            // .match(/^-?\d+(?:\.\d{0,2})?/)}
                        }
                    </Label>
                  </Col>
                  <Col xs={1} className="text-center ptop_unset pbottom_unset">
                    <Label className="font-weight-body">
                      {piiF_t === 0
                        ? null
                        : (
                            (Number(piiF_t) + Number(piiF_ing)) /
                            (materia.length - materiaIng.length + 1)
                          ).toFixed(2)
                            // .toString()
                            // .match(/^-?\d+(?:\.\d{0,2})?/)}
                        }
                    </Label>
                  </Col>
                  <Col xs={1} className="text-center ptop_unset pbottom_unset">
                    <Label className="font-weight-body">
                      {

                      piiiF_t === 0
                        ? null
                        : (
                            (Number(piiiF_t) + Number(piiiF_ing)) /
                            (materia.length - materiaIng.length + 1)
                          ).toFixed(2)
                            // .toString()
                            // .match(/^-?\d+(?:\.\d{0,2})?/)}
                        }
                    </Label>
                  </Col>
                  <Col xs={3} className="text-center">
                    <Label className="font-weight-bold">
                      {" "}
                      {((
                        ( Number(((Number(piF_t) + Number(Number.isNaN(piF_ing)?0:piF_ing)) / (materia.length - materiaIng.length + 1)).toFixed(2)) + 
                          Number(((Number(piiF_t) + Number(Number.isNaN(piiF_ing)?0:piiF_ing)) / (materia.length - materiaIng.length + 1)).toFixed(2)) +
                          Number(((Number(piiiF_t) + Number(Number.isNaN(piiiF_ing)?0:piiiF_ing)) / (materia.length - materiaIng.length + 1)).toFixed(2))
                        ))
                        /
                        prom_div).toString().substr(0, 5)       
        }
                    </Label>
                  </Col>
                </Row>
                <Row className="mt-5 boletin-primer-c-observacion">
                  <Col xs={7} className="">
                    <Row className="border-boletin border-right-u">
                      <Col
                        xs={6}
                        className="border-boletin border-top-u border-left-u border-right-u text-center"
                      >
                        <Label className="font-weight-bold label-boletin">
                          HABITOS Y APTITUDES
                        </Label>
                      </Col>
                      <Col
                        xs={2}
                        className="border-boletin text-center border-top-u"
                      >
                        <Label className="font-weight-bold">1ro.</Label>
                      </Col>
                      <Col
                        xs={2}
                        className="border-boletin text-center  border-top-u"
                      >
                        <Label className="font-weight-bold">2do.</Label>
                      </Col>
                      <Col
                        xs={2}
                        className="border-boletin text-center  border-top-u"
                      >
                        <Label className="font-weight-bold">3ro.</Label>
                      </Col>
                      {props.dataHabitosAptitudes.map((dataHA, i) => {
                        if (dataHA.bh_boletin === data_bl.bl_id) {
                          HabitosA.push(dataHA);
                        }
                        return null;
                      })}
                      {getHabitosAptitudes(HabitosA, props.trimestre)}
                    </Row>
                  </Col>
                  <Col xs={5} className=" border-boletin ">
                    <Row>
                      <Col
                        xs={12}
                        className="border-boletin text-center border-top-u border-left-u border-right-u border-left-u"
                      >
                        <Label className="font-weight-bold label-boletin">
                          OBSERVACIONES
                        </Label>
                      </Col>

                      <Col xs={12}>
                        {HabitosA[0] === undefined ? (
                          <React.Fragment>
                            <Label className="font-weight-bold mt-2">
                              Primer Trimestre
                            </Label>
                            <br></br>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <Label className="font-weight-bold pmaunset ">
                              Primer Trimestre
                            </Label>
                            <br></br>
                            <Label className="pmaunset">
                              {HabitosA[0].bh_observacion}
                            </Label>
                            <br></br>
                          </React.Fragment>
                        )}
                        {HabitosA[1] === undefined ? (
                          <React.Fragment>
                            <Label className="font-weight-bold mt-2 ">
                              Segundo Trimestre
                            </Label>
                            <br></br>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <Label className="font-weight-bold pmaunset">
                              Segundo Trimestre
                            </Label>
                            <br></br>
                            <Label className="pmaunset">
                              {HabitosA[1].bh_observacion}
                            </Label>
                            <br></br>
                          </React.Fragment>
                        )}
                        {HabitosA[2] === undefined ? (
                          <React.Fragment>
                            <Label className="font-weight-bold mt-4">
                              Tercer Trimestre
                            </Label>
                            <br></br>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <Label className="font-weight-bold pmaunset">
                              Tercer Trimestre
                            </Label>
                            <br></br>
                            <Label className="pmaunset">
                              {HabitosA[2].bh_observacion}
                            </Label>
                            <br></br>
                          </React.Fragment>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col xs={7} className="border-boletin border-right-u">
                    <Row>
                      <Col xs={6} className="text-left">
                        <Label className="font-weight-bold">Tardanzas</Label>
                      </Col>
                      <Col
                        xs={2}
                        className="border-boletin text-center  border-top-u"
                      >
                        <Label className="font-weight-bold label-a-t">
                          {ti}
                        </Label>
                      </Col>
                      <Col
                        xs={2}
                        className="border-boletin text-center  border-top-u"
                      >
                        <Label className="font-weight-bold label-a-t">
                          {tii}
                        </Label>
                      </Col>
                      <Col
                        xs={2}
                        className="border-boletin text-center  border-top-u"
                      >
                        <Label className="font-weight-bold label-a-t">
                          {tiii}
                        </Label>
                      </Col>
                      <Col xs={6} className="text-left">
                        <Label className="font-weight-bold">Ausencias</Label>
                      </Col>
                      <Col
                        xs={2}
                        className="border-boletin text-center  border-top-u border-bottom-u"
                      >
                        <Label className="font-weight-bold label-a-t">
                          {ai}
                        </Label>
                      </Col>
                      <Col
                        xs={2}
                        className="border-boletin text-center  border-top-u  border-bottom-u"
                      >
                        <Label className="font-weight-bold label-a-t">
                          {aii}
                        </Label>
                      </Col>
                      <Col
                        xs={2}
                        className="border-boletin text-center  border-top-u  border-bottom-u"
                      >
                        <Label className="font-weight-bold label-a-t">
                          {aiii}
                        </Label>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={5} className="border-boletin">
                    <Row></Row>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col xs={4} className="text-left border-boletin">
                    <Label className="font-weight-boletin">
                      HABITOS Y ACTITUDES SE CALIFICARAN ASI: <br></br>S =
                      PROGRESO SATISFACTORIO <br></br>R = PROGRESO REGULAR{" "}
                      <br></br>X = NO SATISFACE
                    </Label>
                  </Col>
                  <Col xs={8} className="border-boletin">
                    <Row>
                      <Col xs={12} className="text-center">
                        <Label className="font-weight-boletin">
                          LAS CALIFICACIONES INDICAN EL PROGRESO ASI:
                        </Label>
                      </Col>
                      <Col xs={6} className="text-left">
                        <Label className="font-weight-boletin">
                          5: INDICA PROGRESO EXCELENTE DEL ALUMNO <br></br>
                          4: INDICA PROGRESO SATISFACTORIO <br></br>
                          3: INDICA PROGRESO REGULAR
                        </Label>
                      </Col>
                      <Col xs={6} className="text-left">
                        <Label className="font-weight-boletin">
                          2: INDICA PROGRESO DEFICIENTE <br></br>
                          1: NO HAY PROGRESO APRECIABLE
                        </Label>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="mt-5 mb-5">
                  <Col xs={6} className="text-center">
                    <Label className="font-weight-bold">
                      _______________________________________ <br></br>
                      Profesor(a) Consejero(a)
                    </Label>
                  </Col>
                  <Col xs={6} className="text-center">
                    <Label className="font-weight-bold">
                      _______________________________________ <br></br>
                      Gladys N. Méndez<br></br>
                      Director(a)
                    </Label>
                  </Col>
                  <Col xs={12} className="text-center mt-4">
                    <Label>
                      ______________________________________________________________________________________________________________________________________________
                      <br></br>
                      Nota: Este documento no es válido si no contiene el sello
                      del colegio y la firma del director(a).
                    </Label>
                  </Col>
                </Row>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    );
  }

  handlerExportBoletinSegundoCiclo() {
    const props = this.state;
    var prom_div = 1;
    var area = [];
    var boletin_id = [];
    var hashBoletin = {};
    var hashArea = {};
    var materia = [];
    var hashMateria = {};
    var materiaIng = [];
    var hashMateriaIng = {};
    area = props.dataPromedio.filter((o) =>
      hashArea[o.ar_id] || o.ar_id === null ? false : (hashArea[o.ar_id] = true)
    );
    materia = props.dataPromedio.filter((o) =>
      hashMateria[o.as_id] || o.as_id === null
        ? false
        : (hashMateria[o.as_id] = true)
    );
    // console.log(materia);
    materiaIng = props.dataPromedio.filter((o) =>
    hashMateriaIng[o.as_id] || o.as_id === null || o.as_mother !== "17"
      ? false
      : (hashMateriaIng[o.as_id] = true)
  );
console.log(materiaIng);
    boletin_id = props.dataPromedio.filter((o) =>
      hashBoletin[o.bl_id] || o.bl_id === null
        ? false
        : (hashBoletin[o.bl_id] = true)
    );
    if (props.trimestre === "III") {
      prom_div = 3;
    } else if (props.trimestre === "II") {
      prom_div = 2;
    }
    return (
      <div className="mt-2 boletin-container-padd">
        {boletin_id.map((data_bl, i) => {
          var tardanzas = [];
          var ausencias = [];
          var ti = 0;
          var tii = 0;
          var tiii = 0;
          var ai = 0;
          var aii = 0;
          var aiii = 0;
          var piF = 0;
          var piiF = 0;
          var piiiF = 0;
          var pF = 0;

          //INGLES
          var pi_ing = 0;
          var pii_ing = 0;
          var piii_ing = 0;
          var piF_ing = 0;
          var piiF_ing = 0;
          var piiiF_ing = 0;
          var pF_ing = 0;
          var qty_ing = 0;

          
          var notaET_i_ing = 0;
          var notaET_ii_ing = 0;
          var notaET_iii_ing = 0;
          


          //
          props.dataAsistant.map((item) => {
            if (item.asi_asistant === "T" && item.bl_id === data_bl.bl_id)
              tardanzas.push({
                asi_asistant: item.asi_asistant,
                asi_trimestre: item.asi_trimestre,
                count: item.count,
              });
            else if (item.asi_asistant === "A" && item.bl_id === data_bl.bl_id)
              ausencias.push({
                asi_asistant: item.asi_asistant,
                asi_trimestre: item.asi_trimestre,
                count: item.count,
              });
            return null;
          });

          ausencias.map((data, i) => {
            if (data.asi_trimestre === "I") {
              ai = data.count;
            } else if (data.asi_trimestre === "II") {
              aii = data.count;
            } else if (data.asi_trimestre === "III") {
              aiii = data.count;
            }
            return null;
          });

          tardanzas.map((data, i) => {
            if (data.asi_trimestre === "I") {
              ti = data.count;
            } else if (data.asi_trimestre === "II") {
              tii = data.count;
            } else if (data.asi_trimestre === "III") {
              tiii = data.count;
            }
            return null;
          });
          //INGLES
          var array_i=[];
          var array_ii=[];
          var array_iii=[];
          materiaIng.map((dataMIngles)=>{
            var aprec_i_ing = 0;
            var aprecCount_i_ing = 0;
            var notaD_i_ing = 0;
            var notaDCount_i_ing = 0;
            var aprec_ii_ing = 0;
            var notaD_ii_ing = 0;
            var aprecCount_ii_ing = 0;
            var notaDCount_ii_ing = 0;
            var aprec_iii_ing = 0;
            var notaD_iii_ing = 0;
            var aprecCount_iii_ing = 0;
            var notaDCount_iii_ing = 0;
          props.dataPromedio.map((itemP_ing, i) => {
            if (itemP_ing.bl_id === data_bl.bl_id && itemP_ing.as_mother === "17" && dataMIngles.as_id=== itemP_ing.as_id) {
              qty_ing = qty_ing + 1;
              // if(dataMIngles.as_id=== itemP_ing.as_id){
                if (itemP_ing.not_trimestre === "I") {
                  if (itemP_ing.di_typeassignment === "3") {
                    aprec_i_ing = Number(aprec_i_ing) + Number(itemP_ing.not_promedio);
                    aprecCount_i_ing = Number(aprecCount_i_ing) + 1;
                  } else if (itemP_ing.di_typeassignment === "6") {
                    notaET_i_ing = Number(itemP_ing.not_promedio);
                  } else {
                    notaD_i_ing =Number(notaD_i_ing) + Number(itemP_ing.not_promedio);
                    notaDCount_i_ing = Number(notaDCount_i_ing) + 1;
                  }

                  pi_ing = (aprec_i_ing / aprecCount_i_ing) + (notaD_i_ing / notaDCount_i_ing) + notaET_i_ing;
                  // if(itemP_ing.as_id==="10"){
                                      // console.log(aprec_i_ing)4.9
                                      // console.log(aprecCount_i_ing)
                                      // console.log(notaD_i_ing)//4.4
                                      // console.log(notaDCount_i_ing)
                                      // console.log(notaET_i_ing)//4.3
                                      // console.log(pi_ing/3)
                  // }
                } else if (itemP_ing.not_trimestre === "II") {
                  if (itemP_ing.di_typeassignment === "3") {
                    aprec_ii_ing =Number(aprec_ii_ing) + Number(itemP_ing.not_promedio);
                    aprecCount_ii_ing = Number(aprecCount_ii_ing) + 1;
                  } else if (itemP_ing.di_typeassignment === "6") {
                    notaET_ii_ing = Number(itemP_ing.not_promedio);
                  } else {
                    notaD_ii_ing =Number(notaD_ii_ing) + Number(itemP_ing.not_promedio);
                    notaDCount_ii_ing = Number(notaDCount_ii_ing) + 1;
                  }

                  pii_ing = (aprec_ii_ing / aprecCount_ii_ing) + (notaD_ii_ing / notaDCount_ii_ing) + notaET_ii_ing;

                } else if (itemP_ing.not_trimestre === "III") {
                  if (itemP_ing.di_typeassignment === "3") {
                    aprec_iii_ing =Number(aprec_iii_ing) + Number(itemP_ing.not_promedio);
                    aprecCount_iii_ing = Number(aprecCount_iii_ing) + 1;
                  } else if (itemP_ing.di_typeassignment === "6") {
                    notaET_iii_ing = Number(itemP_ing.not_promedio);
                  } else {
                    notaD_iii_ing =Number(notaD_iii_ing) + Number(itemP_ing.not_promedio);
                    notaDCount_iii_ing = Number(notaDCount_iii_ing) + 1;
                  }

                  piii_ing = (aprec_iii_ing / aprecCount_iii_ing) + (notaD_iii_ing / notaDCount_iii_ing) +notaET_iii_ing;
                  // piii_ing= piii_ing/3;

                  // piii_ing = piii_ing+Number(itemP_ing.not_promedio);
                }
                
              }

            // }
          //  console.log(aprec_i_ing)
          //  console.log(aprecCount_i_ing)
           
            return null;
          });
          array_i.push({
            prom:TruncarNotas(Number(pi_ing / 3), 1)[0],
            as_id:dataMIngles.as_id,
            as_desc:dataMIngles.as_desc,
          })
                    array_ii.push({
            prom:TruncarNotas(Number(pii_ing / 3), 1)[0],
            as_id:dataMIngles.as_id,
            as_desc:dataMIngles.as_desc,
          })
                    array_iii.push({
            prom:TruncarNotas(Number(piii_ing / 3), 1)[0],
            as_id:dataMIngles.as_id,
            as_desc:dataMIngles.as_desc,
          })
          // console.log(pi_ing)
         
          })

          console.log(array_i)
            console.log(array_ii)
              console.log(array_iii)
          var r_i=0;
          var r_iC=0;
          var r_ii=0;
          var r_iiC=0;
          var r_iii=0;
          var r_iiiC=0;
          array_i.map((data)=>{ 
            r_iC = r_iC+1;
            r_i=r_i+Number(data.prom);
          });
          array_ii.map((data)=>{ 
            r_iiC = r_iiC+1;
            r_ii=r_ii+Number(data.prom);
          });
          array_iii.map((data)=>{ 
            r_iiiC = r_iiiC+1;
            r_iii=r_iii+Number(data.prom);
          });

          piF_ing = Number((r_i/r_iC).toFixed(2));
          piiF_ing = Number((r_ii/r_iiC).toFixed(2));
          piiiF_ing = Number((r_iii/r_iiiC).toFixed(2));

          pF_ing = Number((pF_ing + Number(Number.isNaN(piF_ing)?0:piF_ing) +  Number(Number.isNaN(piiF_ing)?0:piiF_ing) + Number(Number.isNaN(piiiF_ing)?0:piiiF_ing)));
          var HabitosA = [];
          return (
            <React.Fragment key={i}>
              <div className="container-print">
                <Row>
                  <Col xs={12} className="text-center mt-4 mb-2">
                    <h5 className="font-weight-bold">
                      MINISTERIO DE EDUCACION
                    </h5>
                    <h4 className="font-weight-bold">THE KING'S SCHOOL</h4>
                    <h6>AVENIDA 3RA BARRIO EL CARMEN ENTRE CALLE F Y G SUR</h6>
                    <h5 className="font-weight-bold">
                      BOLETIN DE CALIFICACIONES
                    </h5>
                  </Col>
                </Row>
                <Row className="mb-2 mt-2">
                  <Col xs={6} className="border-boletin">
                    <Label className="font-weight-body">
                      Cédula: &nbsp; &nbsp; &nbsp;{data_bl.per_cedula}
                      <br></br>
                      Nombre: &nbsp; &nbsp;{`${data_bl.per_name}`} <br></br>
                      <br></br>
                    </Label>
                  </Col>
                  <Col xs={6} className="border-boletin">
                    <Label className="font-weight-body">
                      Año Lectivo: &nbsp; &nbsp;{" "}
                      {props.dataRegistrationSelected.reg_year === ""
                        ? props.year
                        : props.dataRegistrationSelected.reg_year}{" "}
                      <br></br>
                      Grupo: &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                      &nbsp;{" "}
                      {props.dataRegistrationSelected.gr_desc === ""
                        ? props.dataGradeSelected.gr_desc
                        : props.dataRegistrationSelected.gr_desc}{" "}
                      <br></br>
                      Consejero(a): &nbsp; &nbsp;
                      {props.dataRegistrationSelected.per_consejero === ""
                        ? props.dataRegistration[0].per_consejero
                        : props.dataRegistrationSelected.per_consejero}{" "}
                      <br></br>
                    </Label>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={6} className="border-boletin  text-left">
                    <Label className="font-weight-bold label-boletin">
                      AREAS
                    </Label>
                  </Col>
                  <Col xs={1} className="border-boletin text-center">
                    <Label className="font-weight-bold label-boletin">I</Label>
                  </Col>
                  <Col xs={1} className="border-boletin  text-center">
                    <Label className="font-weight-bold label-boletin">II</Label>
                  </Col>
                  <Col xs={1} className="border-boletin  text-center">
                    <Label className="font-weight-bold label-boletin">
                      III
                    </Label>
                  </Col>
                  <Col xs={3} className="border-boletin text-center">
                    <Label className="font-weight-bold label-boletin">
                      FINAL
                    </Label>
                  </Col>
                </Row>
                <Row>
                  {area.map((data) => {
                    return (
                      <React.Fragment key={data.ar_id}>
                        <Col xs={12} className="text-left">
                          <Label className="font-weight-bold">
                            {data.ar_desc.toUpperCase()}
                          </Label>
                        </Col>
                        {materia.map((itemM, i) => {
                          if (
                            itemM.ar_id === data.ar_id &&
                            itemM.as_mother === "0"
                          ) {
                            var pi = 0;
                            var pii = 0;
                            var piii = 0;

                            var aprec_i = 0;
                            var notaET_i = 0;
                            var notaD_i = 0;
                            var aprecCount_i = 0;
                            var notaDCount_i = 0;

                            var aprec_ii = 0;
                            var notaET_ii = 0;
                            var notaD_ii = 0;
                            var aprecCount_ii = 0;
                            var notaDCount_ii = 0;

                            var aprec_iii = 0;
                            var notaET_iii = 0;
                            var notaD_iii = 0;
                            var aprecCount_iii = 0;
                            var notaDCount_iii = 0;

                            props.dataPromedio.map((itemP, i) => {

                              if (itemP.bl_id === data_bl.bl_id) {
                                if (itemP.not_trimestre === "I" && itemP.ar_id === data.ar_id && itemM.as_id === itemP.as_id) {

                                  if (itemP.di_typeassignment === "3") {
                                    aprec_i =Number(aprec_i) + Number(itemP.not_promedio);
                                    aprecCount_i = Number(aprecCount_i) + 1;
                                  } else if (itemP.di_typeassignment === "6") {
                                    notaET_i = Number(itemP.not_promedio);
                                  } else {
                                    notaD_i =Number(notaD_i) + Number(itemP.not_promedio);
                                    notaDCount_i = Number(notaDCount_i) + 1;
                                  }
                                  var flagD =0;
                                  var flagA =0;
                                  if (notaDCount_i === 0) {
                                    flagD=1;
                                    notaDCount_i = 1;
                                  }
                                  if (aprecCount_i === 0) {
                                    flagA=1;
                                    aprecCount_i = 1;
                                  }

                                  pi = (aprec_i / aprecCount_i) + (notaD_i / notaDCount_i) + notaET_i;
                                  pi = Number((pi / 3));

                                  if(flagD===1){
                                    notaDCount_i = 0;
                                  }
                                  if(flagA===1){
                                    aprecCount_i = 0;
                                  }
  
                                } else if (itemP.not_trimestre === "II" && itemP.ar_id === data.ar_id && itemM.as_id === itemP.as_id) {  
                                  if (itemP.di_typeassignment === "3") {
                                    aprec_ii = Number(aprec_ii) + Number(itemP.not_promedio);
                                    aprecCount_ii = Number(aprecCount_ii) + 1;
                                  } else if (itemP.di_typeassignment === "6") {
                                    notaET_ii = Number(itemP.not_promedio);
                                  } else {
                                    notaD_ii = Number(notaD_ii) + Number(itemP.not_promedio);
                                    notaDCount_ii = Number(notaDCount_ii) + 1;
                                  }

                                  pii =aprec_ii / aprecCount_ii + notaD_ii / notaDCount_ii + notaET_ii;
                                  pii = Number((pii / 3));
                                } else if (itemP.not_trimestre === "III" && itemP.ar_id === data.ar_id && itemM.as_id === itemP.as_id) {
                                  if (itemP.di_typeassignment === "3") {
                                    aprec_iii = Number(aprec_iii) + Number(itemP.not_promedio);
                                    aprecCount_iii = Number(aprecCount_iii) + 1;
                                  } else if (itemP.di_typeassignment === "6") {
                                    notaET_iii = Number(itemP.not_promedio);
                                  } else {
                                    notaD_iii = Number(notaD_iii) + Number(itemP.not_promedio);
                                    notaDCount_iii = Number(notaDCount_iii) + 1;
                                  }

                                  piii =aprec_iii / aprecCount_iii + notaD_iii / notaDCount_iii + notaET_iii;
                                  piii = Number((piii / 3));
                                }
                              }
                              return null;
                            });

                            piF = Number((piF + Number(pi)).toFixed(2));
                            piiF = Number((piiF + Number(pii)).toFixed(2));
                            piiiF = Number((piiiF + Number(piii)).toFixed(2));
                            pF = Number((pF + (Number(pi) + Number(pii) + Number(piii))).toFixed(2));
                            return (
                              <React.Fragment key={i}>
                                <Col
                                  xs={6}
                                  className="text-left ptop_unset pbottom_unset"
                                >
                                  <Label className="font-weight-body">
                                    {itemM.as_desc}
                                  </Label>
                                </Col>
                                <Col
                                  xs={1}
                                  className="text-center ptop_unset pbottom_unset"
                                >
                                  <Label className="font-weight-body">
                                    {pi === 0 ? null : pi.toFixed(2)}
                                  </Label>
                                </Col>
                                <Col
                                  xs={1}
                                  className="text-center ptop_unset pbottom_unset"
                                >
                                  <Label className="font-weight-body">
                                    {pii === 0 ? null : pii.toFixed(2)}
                                  </Label>
                                </Col>
                                <Col
                                  xs={1}
                                  className="text-center ptop_unset pbottom_unset"
                                >
                                  <Label className="font-weight-body">
                                    {piii === 0 ? null :piii.toFixed(2)}
                                  </Label>
                                </Col>
                                <Col xs={3} className="text-center">
                                  {" "}
                                  <Label className="font-weight-body">
                                    {" "}
                                    {(Number(pi + pii + piii) / prom_div).toFixed(2)}
                                  </Label>{" "}
                                </Col>
                              </React.Fragment>
                            );
                          }

                          return null;
                        })}
                        {pF !== 0 && data.ar_id === "7" ? (
                          <React.Fragment key={i}>
                            <Col
                              xs={6}
                              className="text-left ptop_unset pbottom_unset"
                            >
                              <Label className="font-weight-body">Inglés</Label>
                            </Col>
                            <Col
                              xs={1}
                              className="text-center ptop_unset pbottom_unset"
                            >
                              <Label className="font-weight-body">
                                {piF_ing === 0.00|| piF_ing === 0
                                  ? null
                                  : 
                                  Number.isNaN(piF_ing)?null:
                                  piF_ing.toFixed(2)}
                              </Label>
                            </Col>
                            <Col
                              xs={1}
                              className="text-center ptop_unset pbottom_unset"
                            >
                              <Label className="font-weight-body">
                                {piiF_ing === 0.00|| piiF_ing === 0
                                  ? null
                                  : 
                                  Number.isNaN(piiF_ing)?null:
                                 piiF_ing.toFixed(2)}
                              </Label>
                            </Col>
                            <Col
                              xs={1}
                              className="text-center ptop_unset pbottom_unset"
                            >
                              <Label className="font-weight-body">
                                {piiiF_ing === 0.00 || piiiF_ing === 0
                                  ? null
                                  : 
                                  Number.isNaN(piiiF_ing)?null:
                                  piiiF_ing.toFixed(2)}
                              </Label>
                            </Col>
                            <Col xs={3} className="text-center">
                              {" "}
                              <Label className="font-weight-body">
                                {" "}
                                {(Number(pF_ing) / prom_div).toFixed(2)}
                              </Label>{" "}
                            </Col>
                          </React.Fragment>
                        ) : null}
                      </React.Fragment>
                    );
                  })}
                  <Col xs={6} className="text-left ptop_unset pbottom_unset">
                    <Label className="font-weight-bold">PROMEDIO FINAL</Label>
                  </Col>
                  <Col xs={1} className="text-center ptop_unset pbottom_unset">
                    <Label className="font-weight-body">
                      {piF === 0
                        ? null
                        : (
                            (Number(piF) + Number(piF_ing)) /
                            (materia.length - materiaIng.length + 1)
                          ).toFixed(2)
                            // .toString()
                            // .match(/^-?\d+(?:\.\d{0,2})?/)
                            
                            }
                    </Label>
                  </Col>
                  <Col xs={1} className="text-center ptop_unset pbottom_unset">
                    <Label className="font-weight-body">
                      {piiF === 0
                        ? null
                        : (
                            (Number(piiF) + Number(piiF_ing)) /
                            (materia.length - materiaIng.length + 1)
                          ).toFixed(2)
                            // .toString()
                            // .match(/^-?\d+(?:\.\d{0,2})?/)
                            }
                    </Label>
                  </Col>
                  <Col xs={1} className="text-center ptop_unset pbottom_unset">
                    <Label className="font-weight-body">
                      {piiiF === 0
                        ? null
                        : (
                            (Number(piiiF) + Number(piiiF_ing)) /
                            (materia.length - materiaIng.length + 1)
                          ).toFixed(2)
                            // .toString()
                            // .match(/^-?\d+(?:\.\d{0,2})?/)
                            }
                    </Label>
                  </Col>
                  <Col xs={3} className="text-center">
                    <Label className="font-weight-bold">
                      {" "}
                      {(
                        (pF + pF_ing) /
                        (materia.length - materiaIng.length + 1) /
                        prom_div
                      ).toFixed(3)
                        // .toString()
                        // .match(/^-?\d+(?:\.\d{0,3})?/)
                        
                        }
                    </Label>
                  </Col>
                </Row>
                <Row className="mt-4 boletin-primer-c-observacion">
                  <Col xs={7} className="">
                    <Row className="border-boletin border-right-u">
                      <Col
                        xs={6}
                        className="border-boletin border-top-u border-left-u border-right-u text-center"
                      >
                        <Label className="font-weight-bold label-boletin">
                          HABITOS Y APTITUDES
                        </Label>
                      </Col>
                      <Col
                        xs={2}
                        className="border-boletin text-center border-top-u"
                      >
                        <Label className="font-weight-bold">1ro.</Label>
                      </Col>
                      <Col
                        xs={2}
                        className="border-boletin text-center  border-top-u"
                      >
                        <Label className="font-weight-bold">2do.</Label>
                      </Col>
                      <Col
                        xs={2}
                        className="border-boletin text-center  border-top-u"
                      >
                        <Label className="font-weight-bold">3ro.</Label>
                      </Col>
                      {props.dataHabitosAptitudes.map((dataHA, i) => {
                        if (dataHA.bh_boletin === data_bl.bl_id) {
                          HabitosA.push(dataHA);
                        }
                        return null;
                      })}
                      {getHabitosAptitudes(HabitosA, props.trimestre)}
                    </Row>
                  </Col>
                  <Col xs={5} className=" border-boletin ">
                    <Row>
                      <Col
                        xs={12}
                        className="border-boletin text-center border-top-u border-left-u border-right-u border-left-u"
                      >
                        <Label className="font-weight-bold label-boletin">
                          OBSERVACIONES
                        </Label>
                      </Col>

                      <Col xs={12}>
                        {HabitosA[0] === undefined ? (
                          <React.Fragment>
                            <Label className="font-weight-bold mt-2">
                              Primer Trimestre
                            </Label>
                            <br></br>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <Label className="font-weight-bold pmaunset ">
                              Primer Trimestre
                            </Label>
                            <br></br>
                            <Label className="pmaunset">
                              {HabitosA[0].bh_observacion}
                            </Label>
                            <br></br>
                          </React.Fragment>
                        )}
                        {HabitosA[1] === undefined ? (
                          <React.Fragment>
                            <Label className="font-weight-bold mt-2 ">
                              Segundo Trimestre
                            </Label>
                            <br></br>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <Label className="font-weight-bold pmaunset">
                              Segundo Trimestre
                            </Label>
                            <br></br>
                            <Label className="pmaunset">
                              {HabitosA[1].bh_observacion}
                            </Label>
                            <br></br>
                          </React.Fragment>
                        )}
                        {HabitosA[2] === undefined ? (
                          <React.Fragment>
                            <Label className="font-weight-bold mt-4">
                              Tercer Trimestre
                            </Label>
                            <br></br>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <Label className="font-weight-bold pmaunset">
                              Tercer Trimestre
                            </Label>
                            <br></br>
                            <Label className="pmaunset">
                              {HabitosA[2].bh_observacion}
                            </Label>
                            <br></br>
                          </React.Fragment>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col xs={7} className="border-boletin border-right-u">
                    <Row>
                      <Col xs={6} className="text-left">
                        <Label className="font-weight-bold">Tardanzas</Label>
                      </Col>
                      <Col
                        xs={2}
                        className="border-boletin text-center  border-top-u"
                      >
                        <Label className="font-weight-bold label-a-t">
                          {ti}
                        </Label>
                      </Col>
                      <Col
                        xs={2}
                        className="border-boletin text-center  border-top-u"
                      >
                        <Label className="font-weight-bold label-a-t">
                          {tii}
                        </Label>
                      </Col>
                      <Col
                        xs={2}
                        className="border-boletin text-center  border-top-u"
                      >
                        <Label className="font-weight-bold label-a-t">
                          {tiii}
                        </Label>
                      </Col>
                      <Col xs={6} className="text-left">
                        <Label className="font-weight-bold">Ausencias</Label>
                      </Col>
                      <Col
                        xs={2}
                        className="border-boletin text-center  border-top-u border-bottom-u"
                      >
                        <Label className="font-weight-bold label-a-t">
                          {ai}
                        </Label>
                      </Col>
                      <Col
                        xs={2}
                        className="border-boletin text-center  border-top-u  border-bottom-u"
                      >
                        <Label className="font-weight-bold label-a-t">
                          {aii}
                        </Label>
                      </Col>
                      <Col
                        xs={2}
                        className="border-boletin text-center  border-top-u  border-bottom-u"
                      >
                        <Label className="font-weight-bold label-a-t">
                          {aiii}
                        </Label>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={5} className="border-boletin">
                    <Row></Row>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col xs={4} className="text-left border-boletin">
                    <Label className="font-weight-boletin">
                      HABITOS Y ACTITUDES SE CALIFICARAN ASI: <br></br>S =
                      PROGRESO SATISFACTORIO <br></br>R = PROGRESO REGULAR{" "}
                      <br></br>X = NO SATISFACE
                    </Label>
                  </Col>
                  <Col xs={8} className="border-boletin">
                    <Row>
                      <Col xs={12} className="text-center">
                        <Label className="font-weight-boletin">
                          LAS CALIFICACIONES INDICAN EL PROGRESO ASI:
                        </Label>
                      </Col>
                      <Col xs={6} className="text-left">
                        <Label className="font-weight-boletin">
                          5: INDICA PROGRESO EXCELENTE DEL ALUMNO <br></br>
                          4: INDICA PROGRESO SATISFACTORIO <br></br>
                          3: INDICA PROGRESO REGULAR
                        </Label>
                      </Col>
                      <Col xs={6} className="text-left">
                        <Label className="font-weight-boletin">
                          2: INDICA PROGRESO DEFICIENTE <br></br>
                          1: NO HAY PROGRESO APRECIABLE
                        </Label>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="mt-4 mb-5">
                  <Col xs={6} className="text-center">
                    <Label className="font-weight-bold">
                      _______________________________________ <br></br>
                      Profesor(a) Consejero(a)
                    </Label>
                  </Col>
                  <Col xs={6} className="text-center">
                    <Label className="font-weight-bold">
                      _______________________________________ <br></br>
                      Gladys N. Méndez<br></br>
                      Director(a)
                    </Label>
                  </Col>
                  <Col xs={12} className="text-center mt-4">
                    <Label>
                      ______________________________________________________________________________________________________________________________________________
                      <br></br>
                      Nota: Este documento no es válido si no contiene el sello
                      del colegio y la firma del director(a).
                    </Label>
                  </Col>
                </Row>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    );
  }

  handlerSelectPerson(row: any) {
    this.setState((prevState) => ({
      dataRegistrationSelected: row,
    }));

    setTimeout(() => {
      this.fetchDataBoletin();
    }, 1000);
  }

  handlerSelectBoletin = (cell: string, row: any) => {
    return (
      <React.Fragment>
        <Row>
          <Col xs={12} className="d-flex">
            <Label
              className="txt-underline"
              onClick={() => this.handlerSelectPerson(row)}
            >
              {row.per_cedula}
            </Label>
            <img
              className="img-status img-search"
              onClick={() => this.handlerSelectPerson(row)}
              src={PENCIL}
              alt=""
            />
          </Col>
        </Row>
      </React.Fragment>
    );
  };

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        <Container className="mt-4">
          <Row>
            <Col sm={12} className="text-center">
              <Label className="font-weight-bold">
                <h3>Boletines</h3>
              </Label>
            </Col>
            {props.isOpenPanelBoletin ? (
              <React.Fragment>
                <Col sm={12}>
                  <Row>
                    <Col sm={12} className="text-center">
                      <Label className="font-weight-bold">
                        <h3>{props.trimestre} Trimestre</h3>
                      </Label>
                    </Col>
                    <Col sm={12} className="text-right">
                      <Button
                        color="success"
                        className="mr-2"
                        onClick={() => this.panelBoletin()}
                      >
                        Cerrar
                      </Button>
                    </Col>
                    <Col sm={12}>
                      {props.dataGradeSelected.ar_literal === "1" ? (
                        <REACT_PRINT_COMPONENT
                          body={this.handlerExportBoletinPreescolar()}
                        />
                      ) : props.dataGradeSelected.cy_id === "3" ||
                        props.dataGradeSelected.cy_id === "4" ? (
                        <REACT_PRINT_COMPONENT
                          body={this.handlerExportBoletinSegundoCiclo()}
                        />
                      ) : (
                        <REACT_PRINT_COMPONENT
                          body={this.handlerExportBoletinPrimerCiclo()}
                        />
                      )}
                    </Col>
                  </Row>
                </Col>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Col sm={12} className="text-center mb-3">
                  <PaginationHeaderYear
                    year={props.year}
                    changeHeader={this.changeHeader}
                  />
                </Col>
                <Col sm={12} className="text-center mt-1 mb-3">
                  <Button
                    color="primary"
                    className="mr-2"
                    onClick={() => this.rechargeTrimestre("I")}
                  >
                    I Trimestre
                  </Button>
                  <Button
                    color="danger"
                    className="mr-2"
                    onClick={() => this.rechargeTrimestre("II")}
                  >
                    II Trimestre
                  </Button>
                  <Button
                    color="info"
                    className="mr-2"
                    onClick={() => this.rechargeTrimestre("III")}
                  >
                    III Trimestre
                  </Button>
                </Col>
                <Col sm={12} className="text-center mb-3">
                  <Label className="font-weight-bold">
                    {props.trimestre} Trimestre {props.year}
                  </Label>
                </Col>
                <Col sm={12}>
                  <DatatableExpand
                    data={props.dataGrades}
                    columns={COLUMNS_GRADES()}
                    keyProp="gr_id"
                    expandRow={EXPAND_ROW_GRADE_BOLETINES(
                      this.fetchRegistration,
                      props.dataRegistration,
                      this.exportAllBoletin,
                      this.handlerSelectBoletin
                    )}
                    exportD={false}
                    searchs={false}
                  />
                </Col>
              </React.Fragment>
            )}
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}
export default Boletines;
